export const SITE_BRAND_ADD = "site_brand_add";
export const SITE_BRAND_CLEAN = "site_brand_clean";
export const SET_USER = "set_user";
export const RESET_USER = "reset_user";

export const SITE_BRAND_SEARCH_USER_GET = "site_brand_search_user_get";
